import { classNames } from '@/utils/helpers'

import { iconsMap } from './create-list-form/icon-picker/consts'
import type { TikTokContentListType } from './types'

interface Props {
  list: TikTokContentListType
  className?: string
}

export const ListLabel = ({ list, className }: Props) => {
  const Icon = iconsMap[list.icon]

  return (
    <span
      className={classNames(
        'flex items-center space-x-[10px] text-base font-medium',
        className,
      )}
    >
      {Icon && (
        <Icon
          className="h-6 w-6"
          style={{ color: list.iconColor }}
        />
      )}
      <span>{list.name}</span>
    </span>
  )
}
